module.exports = __webpack_public_path__ + "img/tutorial_classes_02.2c03e9db.gif";